const PushPin = ({ color, ...props }) => (

    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12 20">
        <path id="push_pin_FILL1_wght400_GRAD0_opsz24" d="M16,12l2,2v2H13v6l-1,1-1-1V16H6V14l2-2V5H7V3H17V5H16Z" transform="translate(-6 -3)" fill={color} />
    </svg>
)

export default PushPin;